import { HomePage } from "@/components/pages/home-page"
import LoginPage from "@/app/login/page.web"
import { IS_MOBILE_BUILD } from "@/lib/capacitor"

/** Web: marketing landing. Capacitor: login (matches previous mobile export behaviour). */
export function HomeRoute() {
  if (IS_MOBILE_BUILD) {
    return <LoginPage />
  }
  return <HomePage />
}
